// extracted by mini-css-extract-plugin
export var container = "_2w-0";
export var error = "_2w-9";
export var label = "_2w-5";
export var light = "_2w-6";
export var md = "_2w-3";
export var sm = "_2w-2";
export var thin = "_2w-8";
export var thinBold = "_2w-7";
export var vertical = "_2w-4";
export var xs = "_2w-1";